import Carousel from "react-bootstrap/Carousel";
import { useNewHomeAPI } from "../../hooks/useAllCategoryData";
import ShimmerSingleBox from "../ShimmerSingleBox";

function HomeBanner() {   

  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;
  return (
    <>    
    {isLoading && ( <div className="products home-banner-shimmer">
          {Array.from({ length: 1 }, (_, index) => (
            <ShimmerSingleBox key={index} CustomStyle={{ height: "1510px" }} />
          ))}
        </div> )}
    {data?.banner && (
    <Carousel variant="dark" fade={true} interval={9000} pause={false} touch={true}>  
    {data?.banner?.map((e, i) => (         
          <Carousel.Item key={i}><img src={`${process.env.REACT_APP_IMAGE_URL}/home/banner/${e.url}`} alt="" /></Carousel.Item>    
    ))}
    </Carousel>)}
    </>
  );
}

export default HomeBanner;
